import React, { useState } from "react";
import BreakLine from "../../../component/Desktop/breakLine";
import RowInput from "../../../component/Desktop/rowInput";
import FormInput from "../../../component/FormInput";
import {
  INPUT_TYPE,
  lang,
  MODE_SCREEN,
  REGEX_INPUT,
} from "../../../constants/common.const";
import { Button, Descriptions } from "antd";
import "./unit.scss";
const CustomSegmented = ({ options, value, onChange, disabled }) => {
  return (
    <div className="custom-segmented-unit">
      {options.map((option) => (
        <Button
          key={option.value}
          type={value === option.value ? "primary" : "default"}
          onClick={() => onChange(option.value)}
          disabled={disabled}
          className="segment-button"
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
};

const ViewUnitMaster = ({
  mode,
  currentNode,
  unitData,
  setUnitData,
  inputRefs,
  setIsFillData,
  typeList,
}) => {
  const handleChangeData =
    (key, type = INPUT_TYPE.INPUT, rule) =>
    (e) => {
      const value = !e.target ? e : e.target.value;
      if (rule && Array.isArray(rule) && rule.length > 0) {
        const isValid = rule.some((r) => r.test(value));
        if (!isValid) {
          return;
        }
      }
      if (String(value).length > 255) {
        return;
      }

      setUnitData({
        ...unitData,
        [key]: {
          ...unitData[key],
          value,
        },
      });
      setIsFillData(true);
    };

  const fieldList = [
    {
      title: lang.UNIT_ID,
      key: "unitId",
      value: unitData.unitId,
      type: INPUT_TYPE.INPUT,
      reqrired: true,
      disabled: mode === MODE_SCREEN.EDIT,
      rule: [/^$|^-?\d{1,3}$/],
    },
    {
      title: lang.UNIT_NAME,
      key: "unitName",
      value: unitData.unitName,
      type: INPUT_TYPE.INPUT,
      reqrired: true,
    },
    {
      title: lang.QUANTITY_CATEGORY,
      key: "quantityType",
      value: unitData.quantityType,
      type: INPUT_TYPE.SEGMENTED,
      reqrired: true,
    },
    {
      title: lang.DISPLAY_ORDER,
      key: "displayOrder",
      value: unitData.displayOrder,
      type: INPUT_TYPE.INPUT,
      disabled: true,
    },
  ];
  const renderInput = (f) => {
    if (f.type === INPUT_TYPE.SEGMENTED) {
      return (
        <CustomSegmented
          options={typeList}
          value={f.value.value}
          onChange={(v) => {
            setUnitData({
              ...unitData,
              quantityType: {
                ...unitData.quantityType,
                value: v,
              },
            });
          }}
        />
      );
    }
    return (
      <FormInput
        haveEmptyOption={false}
        refer={(el) => (inputRefs.current[f.key] = el)}
        onChange={handleChangeData(f.key, f.type, f.rule)}
        valueObject={f.value}
        {...f}
      />
    );
  };

  return (
    <div>
      <Descriptions  className="customEquipmentDes"  size="small" column={5} bordered>
        {fieldList.map((item, index) => (
          <Descriptions.Item
            labelStyle={{
              width: "30%",
              fontWeight: "bold",
              display: item.hideTitle && "none",
            }}
            contentStyle={{ padding: "4px 4px", width: 70 }}
            key={index}
            label={
              <div
                style={{
                  cursor:
                    item.required && mode !== MODE_SCREEN.VIEW
                      ? "pointer"
                      : "default",
                  fontWeight: "bold",
                }}
                className="labelInputEquipment"
              >
                <span
                  style={{
                    color: item.reqrired ? "#ff2255" : "",
                  }}
                >
                  {item.title}
                </span>
              </div>
            }
            span={item.span || 5}
          >
            {mode === MODE_SCREEN.VIEW
              ? item.value.valueShow || item.value.value
              : renderInput(item)}
          </Descriptions.Item>
        ))}
      </Descriptions>
    </div>
  );
};

export default ViewUnitMaster;
